import create from 'zustand'
import { devtools, persist } from 'zustand/middleware'

import type { TFase, TFaseGroup } from 'types/classAndPhases'
import type { State } from 'zustand'

export type TSubjectAssessmentSavedFilterStore = State & {
  subjectAssessmentSavedFilters?: {
    phase: TFase
    subject: string
    keyword: string
    phaseGroup: TFaseGroup
  }
  setPhase?: (phase: TFase) => void
  setSubject?: (subject: string) => void
  setKeyword?: (keyword: string) => void
  setPhaseGroup?: (phaseGroup: TFaseGroup) => void
}

const initialState: Partial<TSubjectAssessmentSavedFilterStore> = {
  subjectAssessmentSavedFilters: {
    phase: null,
    subject: null,
    keyword: null,
    phaseGroup: null,
  },
}

export const useSubjectAssessmentSavedFilterStore =
  create<TSubjectAssessmentSavedFilterStore>(
    devtools(
      persist(
        (set, get) => ({
          ...initialState,
          setPhase: (phase) =>
            set({
              subjectAssessmentSavedFilters: {
                ...get().subjectAssessmentSavedFilters,
                phase,
              },
            }),
          setSubject: (subject) =>
            set({
              subjectAssessmentSavedFilters: {
                ...get().subjectAssessmentSavedFilters,
                subject,
              },
            }),
          setKeyword: (keyword) =>
            set({
              subjectAssessmentSavedFilters: {
                ...get().subjectAssessmentSavedFilters,
                keyword,
              },
            }),
          setPhaseGroup: (phaseGroup) =>
            set({
              subjectAssessmentSavedFilters: {
                ...get().subjectAssessmentSavedFilters,
                phaseGroup,
              },
            }),
        }),
        {
          name: 'cur-subject-assessment-saved-filter',
          partialize: ({ subjectAssessmentSavedFilters }) => ({
            subjectAssessmentSavedFilters,
          }),
        }
      )
    )
  )
